/**
 * components/landing/trading-platform/TradingPlatformPage.jsx — Phase 5
 * orchestrator.  Composes the 15 content sections in narrative order.
 */

import SiteFrame from '@/components/landing/SiteFrame'
import Hero          from './sections/Hero'
import Philosophy    from './sections/Philosophy'
import Workspace     from './sections/Workspace'
import Terminal      from './sections/Terminal'
import MarketIntel   from './sections/MarketIntel'
import StrategyBuilder from './sections/StrategyBuilder'
import Backtesting   from './sections/Backtesting'
import Portfolio     from './sections/Portfolio'
import AIAssistant   from './sections/AIAssistant'
import Analytics     from './sections/Analytics'
import MultiAsset    from './sections/MultiAsset'
import Workflow      from './sections/Workflow'
import Enterprise    from './sections/Enterprise'
import WhyChoose     from './sections/WhyChoose'
import FAQ           from './sections/FAQ'
import FinalCTA      from './sections/FinalCTA'

const TradingPlatformPage = () => (
  <SiteFrame hideFooterCta={true}>
    <Hero />             {/* 4  */}
    <Philosophy />       {/* 5  */}
    <Workspace />        {/* 6  */}
    <Terminal />         {/* 7  */}
    <MarketIntel />      {/* 8  */}
    <StrategyBuilder />  {/* 9  */}
    <Backtesting />      {/* 10 */}
    <Portfolio />        {/* 11 */}
    <AIAssistant />      {/* 12 */}
    <Analytics />        {/* 13 */}
    <MultiAsset />       {/* 14 */}
    <Workflow />         {/* 15 */}
    <Enterprise />       {/* 16 */}
    <WhyChoose />        {/* 17 */}
    <FAQ />              {/* 18 */}
    <FinalCTA />         {/* 19 */}
  </SiteFrame>
)

export default TradingPlatformPage
